import React, { useEffect, useState } from 'react'
import DataTable from 'react-data-table-component'
import { Link } from 'react-router-dom'
import axiosAuthInstance from '../../utils/axios/axiosAuthInstance'
import { FiEdit2, FiTrash2, FiEye } from 'react-icons/fi'
import { RiAlertFill } from 'react-icons/ri'
import { getRole } from '../../utils/cookies/cookies'
import columns from '../Task/columns' 

const OverdueTask = () => {
  const [data, setData] = useState([])
  const [pages, setPages] = useState(1)
  const [limit, setLimit] = useState(10)
  const [totalRows, setTotalRows] = useState(0)

  const role = getRole()

  const handleOpenDeleteModal = (id) => {
    console.log('Delete task with id:', id)
  }

  const fetchData = async () => {
    try {
      const response = await axiosAuthInstance.get('task/list', {
          page: pages,
          limit: limit,
          isOverdue: true,
      })

      if (response?.status === 200) {
        const transformedData = response.data.result.docs.map((item) => ({
          ...item,
          name: (
            <div className='flex items-center'>
              {new Date(item.dueDate) < new Date() && (
                <RiAlertFill
                  className='text-red-500 mr-1'
                  title='Overdue Task'
                />
              )}
              <Link to={`/task/view/${item._id}`} className='hover:underline'>
                {item.name}
              </Link>
            </div>
          ),
          actions: (
            <div className='flex items-center'>
              <div className='w-8 h-8 flex items-center justify-center rounded-full hover:bg-primary pointer hover:text-white text-primary'>
                <Link to={`/task/view/${item._id}`}>
                  <FiEye className='w-4 h-4' />
                </Link>
              </div>
              {(role === 'admin' ||
                role === 'HR' ||
                role === 'Social Media Coordinator' ||
                role === 'Team Leader') && (
                <div className='w-8 h-8 flex items-center justify-center rounded-full hover:bg-primary pointer hover:text-white text-primary'>
                  <Link to={`/task/edit/${item._id}`}>
                    <FiEdit2 className='w-4 h-4' />
                  </Link>
                </div>
              )}
              {(role === 'admin' || role === 'HR') && (
                <div
                  className='w-8 h-8 flex items-center justify-center rounded-full hover:bg-primary pointer hover:text-white text-primary'
                  onClick={() => handleOpenDeleteModal(item._id)}
                >
                  <FiTrash2 className='w-4 h-4' />
                </div>
              )}
            </div>
          ),
        }))

        setData(transformedData)
        setTotalRows(response.data.result.totalDocs)
      }
    } catch (error) {
      console.error('Error fetching overdue tasks:', error)
    }
  }

  useEffect(() => {
    fetchData()
  }, [pages, limit])

  const handlePageChange = (newPage) => {
    setPages(newPage)
  }

  const handleLimitPerPageChange = (newLimit) => {
    setLimit(newLimit)
    setPages(1)
  }

  return (
    <div className='p-4'>
      <div className='flex items-center justify-between border-b pb-2 mb-4'>
        <h1 className='text-2xl font-semibold'>Overdue Tasks</h1>
      </div>

      <DataTable
        columns={columns}
        data={data}
        pagination
        paginationServer
        paginationTotalRows={totalRows}
        paginationPerPage={limit}
        paginationRowsPerPageOptions={[10, 20, 30]}
        onChangePage={handlePageChange}
        onChangeRowsPerPage={handleLimitPerPageChange}
      />
    </div>
  )
}

export default OverdueTask
